<template>
  <div
    class="sm-upload-file"
    :class="{
      'preview': showPreview == 'blank',
      'big-preview': showPreview == 'big' && status == 'upload'
    }"
  >
    <div 
      v-if="status == 'new' || status == ''"
      class="sm-upload-file__main"
      :class="status"
      @dragenter="dragEnter = true"
      @dragleave="dragEnter = false"
      @dragover.prevent
      @drop="handleDrop"
      @click="$refs[name].click()"
    >
      <div 
        v-if="dragEnter"
        class="sm-upload-file__drag"
      >
        <span>Drop file here...</span>  
      </div>
      <template v-else>
        <h6 v-if="title">{{title}}</h6>
        <p v-else>
          <span>Drag and drop file here, or </span>
          <a
            href="#"
            class="sm-link"
            @click.prevent
          >upload</a>
        </p>
        <div class="sm-upload-file__main-descr">
          <span 
            v-if="typesText"
            class="sm-small"
          >{{typesText}}</span>
        </div>
      </template> 
    </div>
    <div 
      v-else-if="status == 'upload'"
      class="sm-upload-file__main"
      :class="status"
    >
      <template v-if="showPreview">
        <template v-if="preview">
          <include-svg
            v-if="
              file.type == 'application/pdf' || 
              file.type == 'image/heic' || 
              file.type == 'image/heif'
            "
            :name="statusIcons[status]"
          />
          <img
            v-else
            :src="preview"
          >
        </template>
        <include-svg 
          v-else-if="showPreview == 'blank'"
          :name="statusIcons[status]" 
        />
      </template>
      <div class="sm-upload-file__main-descr">
        <div>
          <span class="sm-small">{{file.name}} </span>
          <a
            href="#"
            class="sm-grey-link sm-small"
            @click.prevent="deleteUpload"
          >Delete</a>
          <span v-if="showPreview == 'big' && file.size">{{formatFileSize(file.size)}}</span>
        </div>
      </div>
    </div>
    <div 
      v-else-if="status == 'error'"
      class="sm-upload-file__main"
      :class="status"
    >
      <div>
        <span class="sm-error sm-small">Upload failed. <template v-if="typesText">Upload {{typesText}} </template></span>
        <a
          href="#"
          class="sm-small"
          @click.prevent="$refs[name].click()"
        >Try again</a>
      </div>
    </div>
    <input 
      :ref="name"
      hidden 
      type="file" 
      :accept="acceptTypes"
      :name="name" 
      @change="uploadFile" 
    />
    <span
      v-if="errors.first(name)"
      class="sm-small sm-error"
    >{{errors.first(name)}}</span>
  </div>
</template>

<script>
import Btn from "@/components/Buttons";
import {IsRightFileType, FormatFileSize} from "@/utils/general-data";
import MimeTypes from '@/settings/mime-types';

export default {
  name: 'upload-file',
  components: {
    'btn-block': Btn,
  },
  props: {
    name: {
      type: String,
      default: 'input'
    },
    title: {
      type: String,
      default: ''
    },
    types: {
      type: Array,
      default: () => []
    },
    typesText: {
      type: String,
      default: ''
    },
    showPreview: {
      type: String,
      default: '' // values: 'blank', 'image', big
    },
    noSave: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: 'new', // values: new, upload, error
      statusIcons: {
        new: 'icon-upload-blank',
        upload: 'icon-upload-success',
        error: 'icon-upload-error'
      },
      file: null,
      preview: null,
      maxFileWeight: 25165824,
      acceptTypes: '',
      dragEnter: false
    };
  },
  created() {
    if (this.types.length) {
      let typesArr = [];
      this.types.forEach(type => typesArr = [...typesArr, MimeTypes[type].join()]);
      this.acceptTypes = typesArr.join();
    }
  },
  methods: {
    isRightFileType: IsRightFileType,
    formatFileSize: FormatFileSize,
    uploadFile(e) {
      if (e.target.files.length === 0) 
        return false;

      const target = e.target;

      this.handleUpload(target.files[0]);
    },
    handleUpload(file) {
      if (this.isRightFileType(file, this.types)) {
        if (this.noSave) {
          this.status = 'new';
          this.$emit('upload', file, this.createPoster(file));
          this.$refs[this.name].value = null;
        } else {
          this.file = file;
          this.status = 'upload';
          this.errors.remove(this.name);
          this.$emit('upload', this.file);

          if (this.showPreview)
            this.preview = this.createPoster(this.file);
        }        
      } else {
        this.status = 'error';
      }
    },
    deleteUpload(e) {
      this.$emit('delete');
      this.status = 'new';
      this.file = null;
      this.preview = null;

      e.stopPropagation();
    },
    createPoster(file) {
      if (!file || file.size > this.maxFileWeight) 
        return false;

      return URL.createObjectURL(file);
    },
    handleDrop(e) {
      e.preventDefault();
      this.dragEnter = false;

      if (e.dataTransfer.files.length === 0) 
        return false;

      this.handleUpload(e.dataTransfer.files[0]);
    }
  }
}
</script>
